import React from "react"
import { SelectSeeker } from "@ui-seeker/core"

import { inTerminal } from "@signals"


export default function InTerminalSelect({ ...props }) {
    return <SelectSeeker
		label="In Terminal"
		value={inTerminal.value}
		isClearable
		onChange={e => inTerminal.value = e.target.value}
		placeholder="Any option"
		options={[
			{ label: 'Option 1', value: 'EUR' },
			{ label: 'Option 2', value: 'GBP' }
		]}
		{...props}
	/>
}